import { css } from 'styled-components';
export default {
    // Font family not included as defined on body in GlobalStyles.ts
    proximaNova: {
        regular: css `
      font-family: proxima-nova, sans-serif;
      font-style: normal;
      font-weight: 400;
    `,
        regularItalic: css `
      font-family: proxima-nova, sans-serif;
      font-weight: 400;
      font-style: italic;
    `,
        medium: css `
      font-family: proxima-nova, sans-serif;
      font-style: normal;
      font-weight: 500;
    `,
        mediumItalic: css `
      font-family: proxima-nova, sans-serif;
      font-weight: 500;
      font-style: italic;
    `,
        semiBold: css `
      font-family: proxima-nova, sans-serif;
      font-style: normal;
      font-weight: 600;
    `,
        semiBoldItalic: css `
      font-family: proxima-nova, sans-serif;
      font-weight: 600;
      font-style: italic;
    `,
        bold: css `
      font-family: proxima-nova, sans-serif;
      font-style: normal;
      font-weight: 700;
    `,
        boldItalic: css `
      font-family: proxima-nova, sans-serif;
      font-weight: 700;
      font-style: italic;
    `,
    },
};
